import { buildModelManager } from "../builder.js";
const DefaultEmailTemplateSelection = {
  __typename: true,
  id: true,
  createdAt: true,
  description: true,
  emailSettings: true,
  htmlContent: true,
  isDefault: true,
  name: true,
  tags: true,
  templateType: true,
  updatedAt: true,
  variables: true
};
const modelApiIdentifier = "email_template";
const pluralModelApiIdentifier = "email_templates";
;
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultEmailTemplateSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultEmailTemplateSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultEmailTemplateSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultEmailTemplateSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultEmailTemplateSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultEmailTemplateSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultEmailTemplateSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createEmailTemplate",
    operationReturnType: "CreateEmailTemplate",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      email_template: { required: false, type: "CreateEmailTemplateInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultEmailTemplateSelection
  },
  {
    type: "action",
    operationName: "bulkCreateEmailTemplates",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateEmailTemplatesInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultEmailTemplateSelection
  },
  {
    type: "action",
    operationName: "updateEmailTemplate",
    operationReturnType: "UpdateEmailTemplate",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      email_template: { required: false, type: "UpdateEmailTemplateInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultEmailTemplateSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateEmailTemplates",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateEmailTemplatesInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultEmailTemplateSelection
  },
  {
    type: "action",
    operationName: "deleteEmailTemplate",
    operationReturnType: "DeleteEmailTemplate",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteEmailTemplates",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "email_template_seedEmailTemplate",
    operationReturnType: "EmailTemplateSeedEmailTemplate",
    functionName: "email_template_seed",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: DefaultEmailTemplateSelection
  },
  {
    type: "action",
    operationName: "bulkEmailTemplateSeedEmailTemplates",
    functionName: "bulkEmailTemplateSeed",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "email_template_seed",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: DefaultEmailTemplateSelection
  },
  {
    type: "action",
    operationName: "upsertEmailTemplate",
    operationReturnType: "UpsertEmailTemplate",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      email_template: { required: false, type: "UpsertEmailTemplateInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateEmailTemplateResult": { hasReturnType: false },
      "... on UpdateEmailTemplateResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultEmailTemplateSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertEmailTemplates",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertEmailTemplatesInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultEmailTemplateSelection
  }
];
const EmailTemplateManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultEmailTemplateSelection,
  operations
);
export {
  DefaultEmailTemplateSelection,
  EmailTemplateManager
};
//# sourceMappingURL=EmailTemplate.js.map
